/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_JoinedInputs */

const id_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabung`)
};

const ms_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertai`)
};

const da_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltog`)
};

const de_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beigetreten`)
};

const en_us2_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joined`)
};

const es_es2_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se unió`)
};

const es_mx2_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se unió`)
};

const fil_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali`)
};

const fr_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrit`)
};

const it_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscritto`)
};

const hu_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csatlakozott`)
};

const nl_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lid geworden`)
};

const no_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ble med`)
};

const pl_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dołączył`)
};

const pt_br2_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingressou`)
};

const pt_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro desde`)
};

const ro_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S-a alăturat`)
};

const fi_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liittynyt`)
};

const sv_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gick med`)
};

const vi_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tham gia`)
};

const tr_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katılma`)
};

const cs_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojil se`)
};

const bg_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присъединил се`)
};

const ru_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присоединился`)
};

const uk_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приєднався`)
};

const ar_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انضم`)
};

const hi_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शामिल हुए`)
};

const th_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าร่วมเมื่อ`)
};

const ja_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加日`)
};

const zh_cn2_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入时间`)
};

const zh_hant1_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入時間`)
};

const ko_profile_hero_joined = /** @type {(inputs: Profile_Hero_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가입일`)
};

/**
* | output |
* | --- |
* | "Joined" |
*
* @param {Profile_Hero_JoinedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_joined = /** @type {((inputs?: Profile_Hero_JoinedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_JoinedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_joined(inputs)
	if (locale === "ms") return ms_profile_hero_joined(inputs)
	if (locale === "da") return da_profile_hero_joined(inputs)
	if (locale === "de") return de_profile_hero_joined(inputs)
	if (locale === "en-US") return en_us2_profile_hero_joined(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_joined(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_joined(inputs)
	if (locale === "fil") return fil_profile_hero_joined(inputs)
	if (locale === "fr") return fr_profile_hero_joined(inputs)
	if (locale === "it") return it_profile_hero_joined(inputs)
	if (locale === "hu") return hu_profile_hero_joined(inputs)
	if (locale === "nl") return nl_profile_hero_joined(inputs)
	if (locale === "no") return no_profile_hero_joined(inputs)
	if (locale === "pl") return pl_profile_hero_joined(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_joined(inputs)
	if (locale === "pt") return pt_profile_hero_joined(inputs)
	if (locale === "ro") return ro_profile_hero_joined(inputs)
	if (locale === "fi") return fi_profile_hero_joined(inputs)
	if (locale === "sv") return sv_profile_hero_joined(inputs)
	if (locale === "vi") return vi_profile_hero_joined(inputs)
	if (locale === "tr") return tr_profile_hero_joined(inputs)
	if (locale === "cs") return cs_profile_hero_joined(inputs)
	if (locale === "bg") return bg_profile_hero_joined(inputs)
	if (locale === "ru") return ru_profile_hero_joined(inputs)
	if (locale === "uk") return uk_profile_hero_joined(inputs)
	if (locale === "ar") return ar_profile_hero_joined(inputs)
	if (locale === "hi") return hi_profile_hero_joined(inputs)
	if (locale === "th") return th_profile_hero_joined(inputs)
	if (locale === "ja") return ja_profile_hero_joined(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_joined(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_joined(inputs)
	return ko_profile_hero_joined(inputs)
});
export { profile_hero_joined as "profile.hero.joined" }